<template>
  <div class="copilot-actions">
    <button
      v-for="action in actions"
      :key="action.id || action.label"
      type="button"
      class="copilot-actions__button"
      :class="`copilot-actions__button--${action.style || 'primary'}`"
      :disabled="action.disabled"
      @click="onClick(action)"
    >
      <i
        v-if="action.icon"
        :class="['copilot-actions__icon', action.icon]"
      />
      <span class="copilot-actions__label">
        {{ action.label }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    actions: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    onClick(action) {
      this.$emit('action-click', action)
    },
  },
}
</script>

<style scoped lang="scss">
.copilot-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.copilot-actions__button {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 2px 8px;
  font-size: 11px;
  cursor: pointer;
  background-color: #fff;
}

.copilot-actions__button--primary {
  background-color: #1a73e8;
  border-color: #1a73e8;
  color: #fff;
}

.copilot-actions__button--secondary {
  background-color: #fff;
  border-color: rgba(0, 0, 0, 0.12);
  color: #333;
}

.copilot-actions__button:disabled {
  opacity: 0.6;
  cursor: default;
}

.copilot-actions__icon {
  margin-right: 4px;
  font-size: 12px;
}

.copilot-actions__label {
  white-space: nowrap;
}
</style>

